module.exports = __webpack_public_path__ + "img/logo.63181c44.png";